
        <div style="display: flex; width: 180px; justify-content: space-between; align-items: center; text-align: center;">
            <svg id="Icons" aria-label="Icon" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60" style="
            background-color: #ff7769;
            border-radius: 100%;
            width: 30;">
              <defs>
                <style>
                  .cls-1 {
                    fill: #ff7769;
                  }
                  .cls-2 {
                    fill: white;
                  }
                  .g {
                  background-color: #ff7769;
                  }
                </style>
              </defs>
              <title>Arrow Right_60px_black</title>

              <g>
                <path class="cls-1" d="M30,3A27,27,0,1,0,57,30,27.03,27.03,0,0,0,30,3Zm0,48.988A21.988,21.988,0,1,1,51.988,30,22.013,22.013,0,0,1,30,51.988Z"/>
                <polygon class="cls-2" points="23.705 22.223 31.277 29.899 23.554 37.306 27.024 40.924 38.415 29.997 27.273 18.703 23.705 22.223"/>
              </g>
              </svg>
                <p style="jh-font-family" style="margin: 0;">Try a test application</p>
            </div>



